export const LOCAL_STORAGE_KEYS = {
  access_logs_default_venue: 'access_logs_default_venue',
  payment_logs_default_venue: 'payment_logs_default_venue',
  ticket_logs_default_venue: 'ticket_logs_default_venue',
  devices_table_column_order: 'devices_table_column_order',
  people_table_column_order: 'people_table_column_order',
  unread_notifications: 'unread_notifications',
  logout_broadcast: 'logout_broadcast',
} as const;
